const philippines = [
  { "name": "Abra", "code": "Abra"}, 
  { "name": "Agusan del Norte", "code": "Agusan del Norte"}, 
  { "name": "Agusan del Sur", "code": "Agusan del Sur"}, 
  { "name": "Aklan", "code": "Aklan"}, 
  { "name": "Albay", "code": "Albay"}, 
  { "name": "Antique", "code": "Antique"}, 
  { "name": "Apayao", "code": "Apayao"}, 
  { "name": "Aurora", "code": "Aurora"}, 
  { "name": "Bataan", "code": "Bataan"}, 
  { "name": "Basilan", "code": "Basilan"}, 
  { "name": "Benguet", "code": "Benguet"}, 
  { "name": "Biliran", "code": "Biliran"}, 
  { "name": "Bohol", "code": "Bohol"}, 
  { "name": "Batangas", "code": "Batangas"}, 
  { "name": "Batanes", "code": "Batanes"}, 
  { "name": "Bukidnon", "code": "Bukidnon"}, 
  { "name": "Bulacan", "code": "Bulacan"}, 
  { "name": "Cagayan", "code": "Cagayan"}, 
  { "name": "Camiguin", "code": "Camiguin"}, 
  { "name": "Camarines Norte", "code": "Camarines Norte"}, 
  { "name": "Camarines Sur", "code": "Camarines Sur"}, 
  { "name": "Capiz", "code": "Capiz"}, 
  { "name": "Catanduanes", "code": "Catanduanes"}, 
  { "name": "Cavite", "code": "Cavite"}, 
  { "name": "Cebu", "code": "Cebu"}, 
  { "name": "Davao Oriental", "code": "Davao Oriental"}, 
  { "name": "Davao del Sur", "code": "Davao del Sur"}, 
  { "name": "Davao del Norte", "code": "Davao del Norte"}, 
  { "name": "Davao Occidental", "code": "Davao Occidental"}, 
  { "name": "Davao de Oro", "code": "Davao de Oro"}, 
  { "name": "Dinagat Islands", "code": "Dinagat Islands"}, 
  { "name": "Eastern Samar", "code": "Eastern Samar"}, 
  { "name": "Guimaras", "code": "Guimaras"}, 
  { "name": "Ifugao", "code": "Ifugao"}, 
  { "name": "Iloilo", "code": "Iloilo"}, 
  { "name": "Ilocos Norte", "code": "Ilocos Norte"}, 
  { "name": "Ilocos Sur", "code": "Ilocos Sur"}, 
  { "name": "Isabela", "code": "Isabela"}, 
  { "name": "Kalinga", "code": "Kalinga"}, 
  { "name": "La Union", "code": "La Union"}, 
  { "name": "Laguna", "code": "Laguna"}, 
  { "name": "Lanao del Norte", "code": "Lanao del Norte"}, 
  { "name": "Lanao del Sur", "code": "Lanao del Sur"}, 
  { "name": "Leyte", "code": "Leyte"}, 
  { "name": "Marinduque", "code": "Marinduque"}, 
  { "name": "Masbate", "code": "Masbate"}, 
  { "name": "Occidental Mindoro", "code": "Occidental Mindoro"}, 
  { "name": "Oriental Mindoro", "code": "Oriental Mindoro"}, 
  { "name": "Maguindanao del Norte", "code": "Maguindanao del Norte"}, 
  { "name": "Maguindanao del Sur", "code": "Maguindanao del Sur"}, 
  { "name": "Mountain Province", "code": "Mountain Province"}, 
  { "name": "Misamis Occidental", "code": "Misamis Occidental"}, 
  { "name": "Misamis Oriental", "code": "Misamis Oriental"}, 
  { "name": "Cotabato (North Cotabato)", "code": "Cotabato (North Cotabato)"}, 
  { "name": "Northern Samar", "code": "Northern Samar"}, 
  { "name": "Negros Occidental", "code": "Negros Occidental"}, 
  { "name": "Negros Oriental", "code": "Negros Oriental"}, 
  { "name": "Nueva Ecija", "code": "Nueva Ecija"}, 
  { "name": "Nueva Vizcaya", "code": "Nueva Vizcaya"}, 
  { "name": "Pampanga", "code": "Pampanga"}, 
  { "name": "Pangasinan", "code": "Pangasinan"}, 
  { "name": "Palawan", "code": "Palawan"}, 
  { "name": "Quezon", "code": "Quezon"}, 
  { "name": "Quirino", "code": "Quirino"}, 
  { "name": "Rizal", "code": "Rizal"}, 
  { "name": "Romblon", "code": "Romblon"}, 
  { "name": "Sarangani", "code": "Sarangani"}, 
  { "name": "South Cotabato", "code": "South Cotabato"}, 
  { "name": "Siquijor", "code": "Siquijor"}, 
  { "name": "Southern Leyte", "code": "Southern Leyte"}, 
  { "name": "Sorsogon", "code": "Sorsogon"}, 
  { "name": "Sulu", "code": "Sulu"}, 
  { "name": "Sultan Kudarat", "code": "Sultan Kudarat"}, 
  { "name": "Surigao del Norte", "code": "Surigao del Norte"}, 
  { "name": "Surigao del Sur", "code": "Surigao del Sur"}, 
  { "name": "Tarlac", "code": "Tarlac"}, 
  { "name": "Tawi-Tawi", "code": "Tawi-Tawi"}, 
  { "name": "Samar (Western Samar)", "code": "Samar (Western Samar)"}, 
  { "name": "Zambales", "code": "Zambales"}, 
  { "name": "Zamboanga del Norte", "code": "Zamboanga del Norte"}, 
  { "name": "Zamboanga del Sur", "code": "Zamboanga del Sur"}, 
  { "name": "Zamboanga Sibugay", "code": "Zamboanga Sibugay"}, 
  { "name": "Metro Manila (National Capital Region)", "code": "NCR"}, 
]

export default philippines;